import Icon from '@/components/ui/AppIcon';

interface Metric {
  label: string;
  value: string;
  icon: string;
  trend: string;
}

interface PerformanceMetricsProps {
  metrics: Metric[];
}

export default function PerformanceMetrics({
  metrics,
}: PerformanceMetricsProps) {
  return (
    <div className="bg-card rounded-lg shadow-subtle p-6 mb-8">
      <h2 className="text-xl font-headline font-bold text-primary mb-6">
        Our Performance Metrics
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {metrics.map((metric, index) => (
          <div
            key={index}
            className="bg-surface rounded-lg p-4 border border-border"
          >
            <div className="flex items-center justify-between mb-3">
              <div className="bg-primary/10 rounded-full p-2">
                <Icon
                  name={metric.icon as any}
                  size={20}
                  className="text-primary"
                />
              </div>
              <span className="text-xs font-body font-semibold text-success">
                {metric.trend}
              </span>
            </div>
            <div className="text-2xl font-headline font-bold text-primary mb-1">
              {metric.value}
            </div>
            <div className="text-xs font-body text-textSecondary">
              {metric.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}